import { useState } from "react";
import Accounts from "./Accounts/Accounts";
import Transactions from "./Transactions/Transactions";

export default function Bank() {
  const [accountID, setAccountID] = useState("");

  if (accountID)
    return (
      <Transactions
        accountID={accountID}
        onChange={(newID) => setAccountID(newID)}
        onBack={() => setAccountID("")}
      />
    );

  return <Accounts onSelect={(newID) => setAccountID(newID)} />;
}
